// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';


function value($$event) {
  return $$event.target.value;
}

exports.value = value;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/ffi/Input.re
// module id = 126
// module chunks = 0